import React, { useContext } from "react";
import { Menu, MenuButton, Avatar, MenuList, MenuItem, Flex, Text, Box, Center, Heading, MenuDivider, } from "@reverb-ui/react";
import { X, Person } from "@reverb-ui/icons-react";
import { AuthContext } from "../../context-api/providers/auth";
import { useHistory } from "react-router";
import Logout from "../../../../assets/icons/log-out.svg";
var formatUserName = function (name) {
    if (name === void 0) { name = ""; }
    var parts = name.split(" ");
    if (parts.length === 1) {
        return "" + parts[0];
    }
    return parts[0] + " " + parts[parts.length - 1];
};
export var ProfileMenu = function () {
    var _a, _b, _c, _d, _e, _f;
    var _g = useContext(AuthContext), user = _g.user, logOut = _g.logOut, exitCockpit = _g.exitCockpit, simulatedEmail = _g.simulatedEmail;
    var history = useHistory();
    return (React.createElement(Menu, null,
        React.createElement(MenuButton, { as: Box },
            React.createElement(Avatar, { name: ((_a = user === null || user === void 0 ? void 0 : user.entity) === null || _a === void 0 ? void 0 : _a.preferredName) || ((_b = user === null || user === void 0 ? void 0 : user.entity) === null || _b === void 0 ? void 0 : _b.name), size: "sm" })),
        React.createElement(MenuList, null,
            React.createElement(Center, { flexDirection: "column", py: 6, px: 6 },
                React.createElement(Avatar, { name: ((_c = user === null || user === void 0 ? void 0 : user.entity) === null || _c === void 0 ? void 0 : _c.preferredName) || ((_d = user === null || user === void 0 ? void 0 : user.entity) === null || _d === void 0 ? void 0 : _d.name), size: "lg" }),
                React.createElement(Heading, { pt: 3, fontWeight: "bold", color: "gray.800", fontSize: "lg" }, formatUserName(((_e = user === null || user === void 0 ? void 0 : user.entity) === null || _e === void 0 ? void 0 : _e.preferredName) || ((_f = user === null || user === void 0 ? void 0 : user.entity) === null || _f === void 0 ? void 0 : _f.name))),
                React.createElement(Text, { color: "gray.600", fontSize: "sm" }, user === null || user === void 0 ? void 0 : user.email)),
            React.createElement(MenuDivider, null),
            React.createElement(Box, null,
                React.createElement(MenuItem, { _focus: { bg: "gray.50" }, onClick: function () { return history.push("/my-account"); } },
                    React.createElement(Person, { color: "gray.500" }),
                    React.createElement(Flex, { pl: "2" },
                        React.createElement(Text, { fontSize: "sm", fontWeight: "medium" }, "My Account"))),
                simulatedEmail && (React.createElement(MenuItem, { _focus: {
                        bg: "gray.50",
                    }, onClick: function () { return exitCockpit(); } },
                    React.createElement(X, { color: "gray.500" }),
                    React.createElement(Flex, { pl: "2" },
                        React.createElement(Text, { fontSize: "sm", fontWeight: "medium" }, "Exit cockpit")))),
                React.createElement(MenuItem, { _focus: { bg: "gray.50" }, onClick: function () { return logOut(); } },
                    React.createElement(Logout, null),
                    React.createElement(Flex, { pl: "2" },
                        React.createElement(Text, { fontSize: "sm", fontWeight: "medium" }, "Sign out")))))));
};
